export default __webpack_public_path__ + "static/media/roadmap-3.672fddd7.png";